const carouselItems = [
  {
    title: '星辰大海',
    tag: '热播剧集',
    desc: '年度科幻巨制，讲述人类探索宇宙的壮丽史诗，特效震撼剧情扣人心弦，全网播放量突破50亿次，豆瓣评分8.6。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20scene%20with%20astronaut%20floating%20near%20a%20massive%20spaceship%2C%20deep%20space%20background%20with%20nebulae%20and%20stars%2C%20warm%20golden%20lighting%20on%20the%20astronaut%2C%20dramatic%20composition%2C%20film%20poster%20aesthetic%2C%20no%20text%20overlay%2C%20high%20contrast%2C%20epic%20scale&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    title: '暗夜追光',
    tag: '悬疑剧场',
    desc: '城市暗夜中的追凶故事，环环相扣的推理情节，每集高能反转不断，国产悬疑剧新标杆。',
    img: 'https://readdy.ai/api/search-image?query=Moody%20noir%20cityscape%20at%20night%20with%20rain-slicked%20streets%2C%20neon%20reflections%2C%20a%20silhouetted%20detective%20figure%2C%20atmospheric%20fog%2C%20dark%20blue%20and%20amber%20color%20palette%2C%20cinematic%20lighting%2C%20mysterious%20vibe%2C%20film%20poster%20style%2C%20no%20text&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    title: '欢乐喜剧人·第八季',
    tag: '综艺热播',
    desc: '国内顶级喜剧竞演节目回归，全新赛制升级，笑星云集爆笑不断，周末必看的欢乐盛宴。',
    img: 'https://readdy.ai/api/search-image?query=Bright%20vibrant%20stage%20with%20colorful%20spotlights%2C%20comedy%20show%20atmosphere%2C%20confetti%20falling%2C%20warm%20golden%20and%20red%20stage%20lighting%2C%20entertainment%20venue%2C%20festive%20mood%2C%20wide%20stage%20view%2C%20professional%20photography%2C%20no%20text&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    title: '山海传说',
    tag: '动画剧场',
    desc: '取材中国上古神话的全新国风动画电影，精美手绘风格，讲述山海经中不为人知的奇幻故事。',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20mythology%20inspired%20landscape%20with%20floating%20mountains%2C%20ancient%20temples%2C%20mythical%20creatures%20in%20mist%2C%20watercolor%20and%20ink%20wash%20painting%20style%2C%20soft%20warm%20tones%2C%20dreamy%20atmosphere%2C%20artistic%20composition%2C%20no%20text&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500">精选热播影视，每日更新推荐</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200 transition-all hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}